enum CommentsView {
    all = 0,
    mine = 1,
    following = 2,
    unread = 3,
    todo = 3
}

export default CommentsView